var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{staticClass:"mysidebar",attrs:{"menu":_vm.menu},on:{"toggle-collapse":_vm.onToggleCollapse}},[_c('span',{attrs:{"slot":"toggle-icon"},slot:"toggle-icon"},[_c('i',{staticClass:"fas fa-arrows-alt-h"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1974278f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = null
// module chunks = 